import React from 'react';
import { ArrowBackIcon, StyledIconLink } from '../../../../ui';
import styled from '@emotion/styled';
import notFound from '../../../../../assets/flights-not-found.svg?reference';
import { StyledFlightDetailHighlight } from './StyledFlightDetailHighlight';
import {
	NoResultsMessage,
	StyledNoResultsMessage,
} from '../../../shared/components';
import { withTranslate } from '../../../shared/i18n/translate';

const StyledNoResultsWrap = styled.div`
	padding-bottom: 20px;
	text-align: center;
	width: 100%;

	${StyledNoResultsMessage} {
		padding: 0px;
	}
`;

export const FlightDetailNoResult = withTranslate<{}>(({ t }) => (
	<StyledFlightDetailHighlight>
		<StyledNoResultsWrap>
			<NoResultsMessage
				title={t('flight_details_not_available')}
				body=""
				imageSource={notFound}
			/>

			<StyledIconLink href="/flights">
				<ArrowBackIcon arria-hidden variation="highlight" />
				{` Flights`}
			</StyledIconLink>
		</StyledNoResultsWrap>
	</StyledFlightDetailHighlight>
));
